import { Injectable, inject } from '@angular/core';
import { calculatePathScore } from '@functions';
import { BoxDetection } from '@models';
import { MetricsService, SimulationService } from '@services';
import { SceneStore } from '@stores';
import { metrics } from './metrics';

@Injectable({
  providedIn: 'root',
})
export class PegTransferMetricsService {
  private metricsService = inject(MetricsService);
  private sceneStore = inject(SceneStore);
  private simulationService = inject(SimulationService);

  metrics = metrics;

  trackLeftTool(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'leftTool');
  }

  trackRightTool(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'rightTool');
  }

  finalizeMetrics() {
    this.metrics.time.value = this.simulationService.recordingTime();
    this.metrics.grasperLeftPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 210,
      maxValue: 610,
      value: this.metricsService.getToolDistance('leftTool'),
    });

    this.metrics.grasperRightPath.value = calculatePathScore({
      maxScore: 15,
      minValue: 170,
      maxValue: 660,
      value: this.metricsService.getToolDistance('rightTool'),
    });

    this.sceneStore.updateMetrics(Object.values(this.metrics));
  }
}
